import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/conversations/{conversationSid}';
type THIS_API = ApiDefinition['/conversations/{conversationSid}']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

/** SWR hook for fetching a conversation by its SID. Pass null to skip the request. */
export const useConversationBySid = (
  params: Input | null,
  config?: UseNoodleSwrConfig<Output>,
): SWRResponse<Output, ApiError> => {
  const path = params ? buildPath<THIS_API>(PATH_TEMPLATE, params) : null;
  return useNoodleSwr(path, { revalidateOnFocus: false, ...config });
};

/**
 * @deprecated: Please use `useConversationBySid` wherever a perfectly fresh response is not worth the network time, bandwidth, and compute.
 */
const getConversationBySid = async ({ conversationSid }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { conversationSid });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getConversationBySid;
